import { useParams } from 'react-router-dom';
import { toValidNumberOrUndefined } from '@/utils/toValidNumberOrUndefined';

export const useCurrentProjectId = (): number | undefined => {
  const { projectId } = useParams();

  return toValidNumberOrUndefined(projectId);
};
